import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';
import {graph} from "./graph";
import {gauge} from "./gauge";

@inheritSerialization(Entity)
export class Consumption extends Entity {

    @deserialize
    secondEndDate = '';

    @deserialize
    graph: Array<graph> = [];

    @deserialize
    gauge: gauge = null;

}
